import { videos } from "../../../mocks/videos";

export default function Hero() {
  const featured = videos[1];

  return (
    <section
      id="top"
      className="relative overflow-hidden bg-background-50 pt-28 md:pt-32"
      aria-label="首屏介绍"
    >
      {/* decorative blobs */}
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-100/70 blur-2xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -left-20 top-40 h-72 w-72 rounded-full bg-accent-100/70 blur-2xl"
        aria-hidden="true"
      />

      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 pb-16 md:grid-cols-2 md:px-6 md:pb-24">
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-semibold text-secondary-900">
            <i className="ri-flashlight-fill text-secondary-700" />
            出圈短视频热门速递 · 每日更新
          </span>

          <h1 className="font-heading mt-6 text-3xl font-black leading-snug text-foreground-950 md:text-5xl md:leading-[1.2]">
            今天全网最出圈的看点，
            <br className="hidden md:block" /> 我们帮你一次刷到爽
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            吃瓜爆网汇聚爆款视频合集盘点、出圈现场与高能名场面，全网疯传的精彩看点按专题精选，热门短视频持续上新，专治刷不到好内容的你。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#collections"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-fill text-lg" />
              开刷今日看点
            </a>
            <a
              href="#rank"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-base font-semibold text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700"
            >
              <i className="ri-fire-line text-lg" />
              看看热度榜
            </a>
          </div>

          {/* quick stats */}
          <dl className="mt-9 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
            <div>
              <dt className="font-heading text-2xl font-black text-primary-600 md:text-3xl">
                8000+
              </dt>
              <dd className="mt-1 text-sm text-foreground-500">累计盘点看点</dd>
            </div>
            <div>
              <dt className="font-heading text-2xl font-black text-accent-600 md:text-3xl">
                50+
              </dt>
              <dd className="mt-1 text-sm text-foreground-500">每日精选更新</dd>
            </div>
            <div>
              <dt className="font-heading text-2xl font-black text-secondary-600 md:text-3xl">
                120+
              </dt>
              <dd className="mt-1 text-sm text-foreground-500">热门专题覆盖</dd>
            </div>
          </dl>
        </div>

        {/* featured card */}
        <div className="w-full">
          <a
            href="#collections"
            className="group block overflow-hidden rounded-2xl border border-background-200 bg-background-50"
          >
            <div className="relative w-full overflow-hidden">
              <img
                src={featured.cover}
                alt="吃瓜爆网本期出圈高能名场面精选封面图"
                title="吃瓜爆网 出圈高能名场面精选"
                className="aspect-[16/10] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-vip-crown-fill" /> 今日爆点
              </span>
              <span className="absolute bottom-4 right-4 inline-flex items-center gap-1 rounded-md bg-black/60 px-2 py-1 text-xs text-background-50">
                <i className="ri-time-line" /> {featured.duration}
              </span>
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-50/85 text-primary-600 backdrop-blur-sm transition-transform group-hover:scale-110">
                  <i className="ri-play-fill text-3xl" />
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-2 p-5">
              <span className="text-sm font-semibold text-primary-600">
                {featured.categoryName}
              </span>
              <h2 className="font-heading text-xl font-bold leading-snug text-foreground-900 md:text-2xl">
                {featured.title}
              </h2>
              <div className="flex items-center gap-4 text-sm text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line" /> {featured.views} 观看
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-fire-fill text-primary-500" /> 热度 {featured.hot}
                </span>
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-800">
                  {featured.tag}
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}